import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BusinessProfileGuard } from 'src/app/core/guards/onboarding/business-profile.guard';
import { StateResolver } from 'src/app/core/resolvers/common/state.resolver';
import { AnnualRevenueResolver } from 'src/app/core/resolvers/onboarding/business-profile/annual-revenue.resolver';
import { BusinessIndustryResolver } from 'src/app/core/resolvers/onboarding/business-profile/business-industry.resolver';
import { BusinessInvoiceResolver } from 'src/app/core/resolvers/onboarding/business-profile/business-invoice.resolver';
import { BusinessTypeResolver } from 'src/app/core/resolvers/onboarding/business-profile/business-type.resolver';
import { CustomerTypeResolver } from 'src/app/core/resolvers/onboarding/business-profile/customer-type.resolver';
import { EmployeeCountResolver } from 'src/app/core/resolvers/onboarding/business-profile/employee-count.resolver';
import { SupportMethodResolver } from 'src/app/core/resolvers/onboarding/business-profile/support-method.resolver';
import { YearFoundedResolver } from 'src/app/core/resolvers/onboarding/business-profile/year-founded.resolver';
import { PageStateClientPersonalizedResolver } from 'src/app/core/resolvers/onboarding/navigation/page-state-client-personalized.resolver';
import { PageStateResolver } from 'src/app/core/resolvers/onboarding/navigation/page-state.resolver';
import { AnnualRevenueComponent } from './annual-revenue/annual-revenue.component';
import { ApplicationSummaryComponent } from './application-summary/application-summary.component';
import { BusinessDescriptionComponent } from './business-description/business-description.component';
import { BusinessIndustryComponent } from './business-industry/business-industry.component';
import { BusinessInvoiceComponent } from './business-invoice/business-invoice.component';
import { BusinessTypeComponent } from './business-type/business-type.component';
import { CompanyAddressComponent } from './company-address/company-address.component';
import { CompanyWebsiteComponent } from './company-website/company-website.component';
import { ConfirmCompanySearchComponent } from './confirm-company-search/confirm-company-search.component';
import { ConfirmDetailsComponent } from './confirm-details/confirm-details.component';
import { CustomerTypeComponent } from './customer-type/customer-type.component';
import { DbaComponent } from './dba/dba.component';
import { EmployeeCountComponent } from './employee-count/employee-count.component';
import { StateOfOrgComponent } from './state-of-org/state-of-org.component';
import { SupportMethodComponent } from './support-method/support-method.component';
import { YearFoundedComponent } from './year-founded/year-founded.component';

const routes: Routes = [
  {
    path: 'business-type',
    component: BusinessTypeComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: BusinessTypeResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'business-industry',
    component: BusinessIndustryComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: BusinessIndustryResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'customer-type',
    component: CustomerTypeComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: CustomerTypeResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'state-of-org',
    component: StateOfOrgComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: StateResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'dba',
    component: DbaComponent,
    resolve: { data: PageStateClientPersonalizedResolver },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'company-address',
    component: CompanyAddressComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: StateResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'annual-revenue',
    component: AnnualRevenueComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: AnnualRevenueResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'company-website',
    component: CompanyWebsiteComponent,
    resolve: { data: PageStateClientPersonalizedResolver },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'year-founded',
    component: YearFoundedComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: YearFoundedResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'employee-count',
    component: EmployeeCountComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: EmployeeCountResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'business-invoice',
    component: BusinessInvoiceComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: BusinessInvoiceResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'lending-method',
    component: SupportMethodComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: SupportMethodResolver,
    },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'confirm-details',
    component: ConfirmDetailsComponent,
    resolve: { data: PageStateClientPersonalizedResolver },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'confirm-company-search',
    component: ConfirmCompanySearchComponent,
    resolve: { data: PageStateClientPersonalizedResolver },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'business-description',
    component: BusinessDescriptionComponent,
    resolve: { data: PageStateClientPersonalizedResolver },
    canActivate: [BusinessProfileGuard],
  },
  {
    path: 'summary',
    component: ApplicationSummaryComponent,
    resolve: { data: PageStateResolver },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [PageStateResolver],
})
export class BusinessProfileRoutingModule {}
